var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import GatingV2Resource from "@ane/exp-data/lib/resources/GatingV2Resource";
import { transitionGateActionTypes, loadingGate, gateLoaded, loadHasGate, hasGateActionTypes, loadingHasGate, hasGateLoaded, resolveGateActionTypes, resolvingGate, gateResolved } from "./ResolveGate.ducks.js";
import { IsByFlight } from "../../utils/GatingUtils.js";
const GetTransitionGateEpic = produceLoadLoadingLoadedEpic({
  filterOnType: transitionGateActionTypes.LOAD,
  loadResource: (payload) => GatingV2Resource.getTransitionGate(payload.gateName),
  loadingAction: () => loadingGate(),
  loadedAction: (response, payload) => {
    let { result } = response;
    const gate = __spreadProps(__spreadValues({}, result), {
      ExemptionMessage: result.ExemptionMessage || `Exempting this gate violates policy and may skip processes which reduce risk and help ensure trustworthy experimentation`
    });
    return of(gateLoaded(getCompletedAsyncWrapperObj(gate, response.error)), loadHasGate(payload.target, response.result));
  }
});
const HasGateEpic = produceLoadLoadingLoadedEpic({
  filterOnType: hasGateActionTypes.LOAD,
  loadResource: (payload) => {
    const { target, gate } = payload;
    const byFlight = IsByFlight(gate.Type);
    return byFlight ? GatingV2Resource.flightHasGate(target, gate.Name) : GatingV2Resource.experimentHasGate(target, gate.Name);
  },
  loadingAction: () => loadingHasGate(),
  loadedAction: (response, payload) => {
    const { target, gate } = payload;
    const error = !(response == null ? void 0 : response.result) ? `Target ${target} doesn't have Gate ${gate.Name}` : response.error;
    return of(hasGateLoaded(getCompletedAsyncWrapperObj(response.result, error)));
  }
});
const ResolveGateEpic = produceLoadLoadingLoadedEpic({
  filterOnType: resolveGateActionTypes.LOAD,
  loadResource: (payload) => {
    const { target, gateName, state, comment, content } = payload;
    return GatingV2Resource.updateExperimentGate(target, gateName, state, comment, content);
  },
  loadingAction: () => resolvingGate(),
  loadedAction: (response) => {
    return of(gateResolved(getCompletedAsyncWrapperObj(response.result, response.error)));
  }
});
const ResolveGateEpics = combineEpics(GetTransitionGateEpic, HasGateEpic, ResolveGateEpic);
export {
  ResolveGateEpics as default
};
//# sourceMappingURL=ResolveGate.epics.js.map
